// Screen 3 · My Classes — list + add. Empty state is encouraging (Design Brief).

import { api } from "../api";
import { esc } from "../dom";

interface Cls {
  id: string;
  name: string;
  level: string | null;
}

export async function renderClasses(app: HTMLElement): Promise<void> {
  app.innerHTML = `
    <div class="topbar"><a data-link href="/" class="muted">← Home</a></div>
    <h1>My Classes</h1>
    <div id="list" class="empty">Loading…</div>
    <h2>Add a class</h2>
    <form id="add">
      <label for="cname">Class name</label>
      <input id="cname" placeholder="G4A" required />
      <label for="clevel">Level</label>
      <input id="clevel" placeholder="Movers" />
      <div style="height:12px"></div>
      <button class="btn" type="submit">Add class</button>
    </form>`;

  async function load(): Promise<void> {
    const { classes } = await api<{ classes: Cls[] }>("/api/classes");
    const list = app.querySelector<HTMLElement>("#list")!;
    if (classes.length === 0) {
      list.className = "empty";
      list.textContent = "Add your first class to start planning.";
      return;
    }
    list.className = "";
    list.innerHTML = classes
      .map(
        (c) =>
          `<a class="card" data-link href="/classes/${esc(c.id)}"><strong>${esc(c.name)}</strong>${
            c.level ? ` <span class="chip">${esc(c.level)}</span>` : ""
          }</a>`,
      )
      .join("");
  }

  app.querySelector<HTMLFormElement>("#add")!.addEventListener("submit", async (e) => {
    e.preventDefault();
    const name = app.querySelector<HTMLInputElement>("#cname")!.value.trim();
    const level = app.querySelector<HTMLInputElement>("#clevel")!.value.trim();
    if (!name) return;
    await api("/api/classes", { method: "POST", body: JSON.stringify({ name, level }) });
    app.querySelector<HTMLFormElement>("#add")!.reset();
    await load();
  });

  await load();
}
